import { formatServerDate, startOfMoscowDay } from './moscowTime';

/**
 * «Регулярные гости», light version (ideas 2026-10-13 #1): a nanny or a cleaner on the same weekdays. v1 has no
 * schedule, so the resident orders a one-day pass for every chosen day of the next weeks at once.
 */
export const WEEKDAYS = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'] as const;
const WEEKDAY_SHORT = ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс'] as const;

/** Monday = 0 … Sunday = 6 of a Moscow calendar day "Y-m-d". */
export function moscowWeekday(ymd: string): number {
  return (new Date(`${ymd}T12:00:00Z`).getUTCDay() + 6) % 7;
}

/** Calendar days ("Y-m-d", Moscow) on the chosen weekdays, from today for the given number of weeks. */
export function regularDates(weekdays: readonly number[], weeks: number, now: Date): string[] {
  const result: string[] = [];
  for (let i = 0; i < weeks * 7; i++) {
    const ymd = formatServerDate(startOfMoscowDay(now, i)).slice(0, 10);
    if (weekdays.includes(moscowWeekday(ymd))) result.push(ymd);
  }
  return result;
}

/** "вт 21.10" — a day in the preview and in the results. */
export function regularDayLabel(ymd: string): string {
  return `${WEEKDAY_SHORT[moscowWeekday(ymd)]} ${ymd.slice(8, 10)}.${ymd.slice(5, 7)}`;
}
